import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import LoadProfileLaneHistoryScorecardItem from "./LoadProfileLaneHistoryScorecardItem/LoadProfileLaneHistoryScorecardItem";

export default function LoadProfileLaneHistoryScorecard({ scorecardData }) {
  return (
    <Box className="Load-profile-component-header">
      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
        {scorecardData.map((item) => (
          <LoadProfileLaneHistoryScorecardItem 
            key={item.label}
            item={item}
          />
        ))}
      </Box>
    </Box>
  );
}

LoadProfileLaneHistoryScorecard.propTypes = {
  scorecardData: PropTypes.array.isRequired
};